import { HttpError } from 'react-admin';

import { execAdminForm } from '@src/apis/reware/utils';

import type {
  UploadMarkdownsExecVariables,
  UploadMarkdownsExecResponse,
  UploadMarkdownsResult,
} from './types';

export interface UploadMarkdownsArgs {
  partnerId: number;
  file: File;
}

/**
 * Uploads a markdown CSV file to set y-adjusted prices for a partner.
 * The CSV must contain columns: parent_sku, sku_subcode, color, size_code,
 * yadjusted_code, yadjusted_price.
 * Prices are in cents (e.g. 4000 = $40.00).
 * yadjusted_code is required for non-zero prices.
 *
 * The file is sent as multipart FormData with key 'markdownCsv' — the reware-api
 * resolver reads it from context.files[0].
 */
export const uploadMarkdowns = async ({
  partnerId,
  file,
}: UploadMarkdownsArgs): Promise<UploadMarkdownsResult> => {
  const query = `
    mutation uploadMarkdowns($partnerId: Int!) {
      partner(id: $partnerId) {
        uploadMarkdowns {
          id
          initiatedAt
          processedAt
        }
      }
    }
  `;

  const data = await execAdminForm<
    UploadMarkdownsExecVariables,
    UploadMarkdownsExecResponse
  >(query, { partnerId }, { markdownCsv: file });

  const result = data.partner?.uploadMarkdowns;
  if (!result) {
    throw new HttpError(
      'Upload completed but the server returned no confirmation. Please refresh to check if it was processed.',
      502
    );
  }

  return result;
};
